import axios from 'axios';
import commentTextareas from './comment-textareas';
import xhrRoutes from '../routes/xhr';
import stringifyObject from '../../helpers/stringify-object';
import Translator from '../translator';

const fn = {
  classCommentButtonHide: 'card__comments__btn--hide',
  classButtonDisabled: 'card__comments__btn--disabled',
  init: () => {
    const commentButtons = document.querySelectorAll('.js-comment-button');

    if (!commentButtons.length) {
      return;
    }

    [].forEach.call(commentButtons, (commentButton) => {
      commentButton.addEventListener('click', () => {
        if (commentButton.classList.contains(fn.classButtonDisabled)) {
          return;
        }

        const commentArea = commentButton.parentNode;
        const commentTextarea = commentArea.querySelector('.js-comment-textarea');
        const commentTextareaValue = commentTextarea.value;

        if (commentTextareaValue === '') {
          return;
        }

        fn.toggleButton(commentButton, 'disable');
        fn.addComment(xhrRoutes.comment.addComment, commentTextarea.getAttribute('data-comment-message-id'), commentTextareaValue).then(() => {
          fn.toggleButton(commentButton, 'enable');
          fn.reset(commentTextarea);
          commentTextareas.init();
          commentTextarea.focus();
          app.msnry.inst.layout();
        });
      });
    });
  },
  addComment(route, messageId, comment) {
    return new Promise((resolve, reject) => {
      route.params.message_id = messageId;
      route.params.comment = comment;

      axios.post(route.url, stringifyObject(route.params))
        .then((response) => {
          if (response.data.status === 'fail') {
            fn.showNotification('error', Translator.trans('api.error.fail'));
          } else {
            fn.showNotification('success', Translator.trans('api.community.comment.added'));
          }

          resolve();
        })
        .catch((error) => {
          console.log(error);
          resolve();
        })
        .then(() => {
          resolve();
        });
    });
  },
  toggleButton(button, state) {
    if (!button.classList.contains(fn.classButtonDisabled) && state === 'disable') {
      button.classList.add(fn.classButtonDisabled);
    } else if (state === 'enable') {
      button.classList.remove(fn.classButtonDisabled);
    }
  },
  showNotification: (type, message) => {
    const notification = document.createElement('div');
    notification.classList.add('notification');
    notification.classList.add(`notification--${type}`);
    notification.innerHTML = message;
    document.body.appendChild(notification);
  },
  reset(commentTextarea) {
    commentTextarea.value = '';
  },
};

export default fn;
